export const SITE_IN_DURATION = 1.2
